module.exports = __webpack_public_path__ + "static/img/bg-en.3183e0f3.webp";